module.exports = __webpack_public_path__ + "img/carshina21_15.3c35b339.jpg";